var __webpack_error__ = new Error();
module.exports = new Promise((resolve, reject) => {
	if(typeof personal_page_video_front !== "undefined") return resolve();
	__webpack_require__.l("https://personal-page-video-front.staging.it-incubator.ru/remoteEntry.js", (event) => {
		if(typeof personal_page_video_front !== "undefined") return resolve();
		var errorType = event && (event.type === 'load' ? 'missing' : event.type);
		var realSrc = event && event.target && event.target.src;
		__webpack_error__.message = 'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
		__webpack_error__.name = 'ScriptExternalLoadError';
		__webpack_error__.type = errorType;
		__webpack_error__.request = realSrc;
		reject(__webpack_error__);
	}, "personal_page_video_front");
}).then(() => (personal_page_video_front));